<template>
  <div id="restaurar-content">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true" />
    <LayoutTelas
      id="tela__restaurarSenha"
      :titulo="this.$route.meta.titulo">

      <b-form @submit.prevent="gravarNovaSenha">
        <InputBasico
          ref="Nova senha"
          type="password"
          label="Nova senha"
          name="senha"
          class="inputSenha"
          v-model="form.password"
          v-validate="'required|min:6'"
          :errorsBag="errors" />

        <InputBasico
          type="password"
          label="Repetir nova senha"
          name="repetirSenha"
          class="inputRepetirSenha"
          v-model="form.passwordConf"
          v-validate="'required|confirmed:Nova senha'"
          :errorsBag="errors" />

        <div class="botoes">
          <b-button
            type="submit"
            variant="primary">
            Gravar
          </b-button>
        </div>
      </b-form>

    </LayoutTelas>
  </div>
</template>

<script>
import bForm from 'bootstrap-vue/es/components/form/form'
import bButton from 'bootstrap-vue/es/components/button/button'
import InputBasico from '@/components/inputs/InputBasico.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'
import autenticacaoService from '../../services/autenticacao.service'

export default {
  name: 'RecuperarSenha',
  components: {
    bForm,
    InputBasico,
    bButton,
  },
  mixins: [GeradorMensagens],
  async mounted() {
    try {
      if (!this.$route.params.id) {
        throw Error('Link inválido!')
      }

      this.isLoading = true
      this.retornoApi = await autenticacaoService
        .retornaDadosUsuarioRecuperacaoSenha(this.$route.params.id)

      this.$refs['Nova senha'].focar()
    } catch (error) {
      this.tratarRespostaMsg(error)
      this.redirecionarLogin()
    } finally {
      this.isLoading = false
    }
  },
  data() {
    return {
      retornoApi: {},
      form: {
        password: '',
        passwordConf: '',
      },
      isLoading: false,
    }
  },
  methods: {
    gravarNovaSenha() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const envio = JSON.parse(JSON.stringify({
            _id: this.retornoApi.usuario._id,
            password: this.form.password,
          }))

          this.isLoading = true
          autenticacaoService.atualizarSenhaRecuperacaoSenha(envio)
            .then(() => this.redirecionarLogin())
            .catch(err => this.tratarRespostaMsg(err))
            .finally(() => {
              this.isLoading = false
            })
        }
      })
    },
    redirecionarLogin() {
      this.$router.push({ name: 'rota-login' })
    },
  },
}

</script>

<style lang="scss" scoped>
@import '@/scss/breakpoints.scss';

#restaurar-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  justify-content: center;
  align-items: center;
  @media (min-width: $medium-size) {
    flex-direction: row;
  }
}

#tela__restaurarSenha {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

.botoes {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

</style>
